import { Priorities, Statuses, SearchFields } from '~/utils/types/job';

export const DEFAULT_PAGE = 1;
export const DEFAULT_SORT_DIRECTION = 'ASC';
export const DEFAULT_ORDER_BY_KEY = 'projectName';

export const STATUS_TABS: Array<string> = ['Sales', 'Production', 'Billing'];
export const STATUS_TABS_JOB_DETAILS: Array<string> = [
  'basicinformation',
  'tasks',
  'scope',
  'dates',
  'activitiesnotes',
  'files',
  'financial',
];

export const TASKS_JOB_DETAILS: Array<{ id: string; title: string }> = [
  { id: 'new', title: 'new' },
  { id: 'contacted', title: 'contacted' },
  { id: 'assessment_Scheduled', title: 'assessment_Scheduled' },
  { id: 'inspected', title: 'inspected' },
  { id: 'estimate_Sent', title: 'estimate_Sent' },
  { id: '1st_flow_up', title: '1st_flow_up' },
  { id: '2nd_flow_up', title: '2nd_flow_up' },
  { id: 'ready_for_Production', title: 'ready_for_Production' },
  { id: 'in_Production', title: 'in_Production' },
  { id: 'work_Completed', title: 'work_Completed' },
  { id: 'invoiced', title: 'invoiced' },
  { id: 'closed', title: 'closed' },
  { id: 'lost', title: 'lost' },
  { id: 'on_Hold', title: 'on_Hold' },
  { id: 'collections', title: 'collections' },
];
export const CHOOSE_TIME_LIST = [15, 30, 45, 60, 90];

export const PRIORITIES: Priorities = ['urgent', 'high', 'normal', 'low'];

export const STATUSES: Statuses = ['progress', 'hold', 'completed'];
export const STATUS_DEFAULT = 'progress';

export const SEARCH_FIELDS: SearchFields = ['name', 'createdBy', 'status', 'deadline'];

export const ROOM_SKETCHES: Array<string> = ['hard_surface', 'carpet', 'heavy', 'weight'];
